import Vue from 'vue';
import {
  makeFilterFunction,
  compareToday,
  formatToday,
} from 'ice.fo.utils/DateUtils';

/**
 * Ex: <div>Today is {{ (new Date()) | textDate }}</div> => Today is 2020.07.24
 */
Vue.filter('textYear', makeFilterFunction('YYYY'));

/**
 * Ex: <div>Today is {{ (new Date()) | textDate }}</div> => Today is 2020.07.24
 */
Vue.filter('textMonth', makeFilterFunction('MM'));

/**
 * Ex: <div>Today is {{ (new Date()) | textDate }}</div> => Today is 2020.07.24
 */
Vue.filter('textMonthDate', makeFilterFunction('MM.DD'));

/**
 * Ex: <div>Today is {{ (new Date()) | textDate }}</div> => Today is 2020.07.24
 */
Vue.filter('textDate', makeFilterFunction('DD/MM/YYYY, h:mm A'));

/**
 * Ex: <div>Today is {{ (new Date()) | textDate }}</div> => Today is 2020.07.24
 */
Vue.filter('textNameDate', makeFilterFunction('MMM DD, YYYY'));

/**
 * Ex: <div>Today is {{ (new Date()) | textDate }}</div> => Today is 2020.07.24 21:33
 */
Vue.filter('textDateTime', makeFilterFunction('DD/MM/YYYY HH:mm:ss'));

/**
 * Ex: <div>Today is {{ (new Date()) | textDate }}</div> => Today is 2020.07.24
 */
Vue.filter('textDateTimeShort', makeFilterFunction('DD/MM/YYYY'));

/**
 * Ex: <div>Today is {{ (new Date()) | textDate }}</div> => Today is 21:33
 */
Vue.filter('textTime', makeFilterFunction('HH:mm'));

/**
 * Ex: <div>Today is {{ (new Date()) | textDate }}</div> => Today is 21:33
 */
Vue.filter('textTimeFull', makeFilterFunction('h:mm A'));

/**
 * Ex: <div>Today is {{ (new Date()) | textDate }}</div> => Today is 24
 */
Vue.filter('textDay', makeFilterFunction('DD'));

/**
 * Ex: <div>Today is {{ (new Date()) | textDate }}</div> => Today is Wed
 */
Vue.filter('textWeekday', makeFilterFunction('ddd'));

/**
 * Ex: <div>Today is {{ (new Date()) | textDate }}</div> => Today is Wed
 */
Vue.filter('compareToday', compareToday);

/**
 * Ex: <div>Today is {{ (new Date()) | textDate }}</div> => Today is Wed
 */
Vue.filter('formatToday', formatToday);
